module.exports = __webpack_public_path__ + "static/media/six-tokens.9b88cbc0.svg";